export default {
  'zh-CN': {
    'clear': '清除全部',
    'noTips': '不再提示',
    'know': '我知道了',
    'notice': '升级公告'
  },
  'en': {
    'clear': 'Remove all',
    'noTips': 'No longer prompt',
    'know': 'I got it',
    'notice': 'Upgrade announcement'
  },
  'jp': {
  }
}
